import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["Features", "/#features"], ["How It Works", "/#how-it-works"], ["Referral Rewards", "/#rewards"], ["FAQ", "/faq"],
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#080A08]/80 border-b border-[#1E281E]" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <Logo />
          <span className="hidden xl:block text-[11px] text-[#7C8A7C] leading-tight max-w-[120px]">By Buddy Innovations &amp; Technologies</span>
        </div>
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map(([l, h]) => (
            <a key={l} href={h} data-testid={`nav-${l.toLowerCase().replace(/ /g, "-")}`}
              className="text-sm text-[#A3ADA3] hover:text-white transition-colors">{l}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/dashboard" data-testid="nav-view-my-stats"
            className={`text-sm px-4 py-2 rounded-full border border-[#1E281E] hover:border-[#B7FF3C]/50 transition-colors ${pathname === "/dashboard" ? "text-[#B7FF3C]" : "text-white"}`}>
            View My Stats
          </Link>
          <Link to="/join" data-testid="nav-join-waitlist"
            className="text-sm font-semibold px-5 py-2.5 rounded-full bg-[#B7FF3C] text-[#080A08] hover:bg-[#c9ff6a] transition-colors flex items-center gap-1.5">
            Join Waitlist <ArrowRight size={15} />
          </Link>
        </div>
        <button className="lg:hidden p-2 text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#1E281E] bg-[#080A08] px-5 py-5 space-y-1" data-testid="nav-mobile-menu">
          {LINKS.map(([l, h]) => (
            <a key={l} href={h} onClick={() => setOpen(false)} className="block py-2.5 text-[#C9D1C9]">{l}</a>
          ))}
          <Link to="/dashboard" onClick={() => setOpen(false)} className="block py-2.5 text-white" data-testid="nav-mobile-stats">View My Stats</Link>
          <Link to="/join" onClick={() => setOpen(false)} className="block mt-3 text-center py-3 rounded-full bg-[#B7FF3C] text-[#080A08] font-semibold" data-testid="nav-mobile-join">Join Waitlist</Link>
          <p className="pt-3 text-xs text-[#7C8A7C]">By Buddy Innovations &amp; Technologies.</p>
        </div>
      )}
    </header>
  );
};
